'use client';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './productTiles.scss';
import { LandingPortableText } from '@/components/landingPortableText/landingPortableText';
import { PortableTextBlock } from 'next-sanity';
import Button from '@/componentv2/button/button';
import Typography from '@/componentv2/typography/typography';
import FontAwesomeIcon from '@/componentv2/fontAwesomeIcon/fontAwesomeIcon';
import { LANDING_OR_PRODUCT_PAGE_QUERY_RESULT } from '@/sanity.types';

interface ProductTilesSectionProps {
  data: NonNullable<LANDING_OR_PRODUCT_PAGE_QUERY_RESULT>;
  section?: 'featuresList' | 'featuresList2';
}

export default function ProductTiles({
  data,
  section = 'featuresList',
}: ProductTilesSectionProps) {
  const featuresList = data?._type === 'productPage' ? data?.[section] : null;

  return (
    <section className="product-tiles-section">
      <Container>
        <Row>
          <Col md={6} className="product-title-col">
            {featuresList?.title && (
              <div className="product-tile-section-title">
                <LandingPortableText
                  value={featuresList?.title as PortableTextBlock[]}
                />
              </div>
            )}
            {featuresList?.cta?.link && (
              <Button variant="primary" href={featuresList?.cta?.link}>
                {featuresList?.cta?.text}
              </Button>
            )}
          </Col>
          <Col md={6} className="product-tile-list-col">
            <div className="product-tile-list">
              {featuresList?.features?.map((item, index) => (
                <div className="product-tile-item" key={index}>
                  <Typography as="h4" style="h4" className="product-tile-title">
                    <FontAwesomeIcon
                      style={item?.icon?.style}
                      name={item?.icon?.name}
                    />
                    {item?.feature}
                  </Typography>
                  <Typography style="paragraph" className="text-black mb-0">
                    {item?.description}
                  </Typography>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
